﻿$.fn.dxCtrlSplitterResize2 = function custom_dxCtrlSplitterResize2(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlsplitterresize2 dx-ctrl");
        this.createInstance(new cdxCtrlSplitterResize2(this, option));
    }
    return this;
}

window.cdxCtrlSplitterResize2 = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid != 'undefined' && option.bddCtrl.utiCourantParaJson) {
        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}
        //if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_visible_left == 'undefined') {
        //    option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_visible_left = true
        //}
        //if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_visible_right == 'undefined') {
        //    option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_visible_right = true
        //}
        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_left == 'undefined') {
            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_left = false
        }
        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right == 'undefined') {
            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right = false
        }
        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_left == 'undefined') {
            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_left = option.widthLeftInitial
        }
        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_right == 'undefined') {
            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_right = option.widthRightInitial
        }
    }

    var dxSplitter = null;
    var $DivRight = null
    var $DivLeft = null
    var $DivContainerRight = null
    var $DivContainerLeft = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")
        container.css("position", "relative")

        let leftItem = null;
        let rightItem = null;
        var $DivSplitter = null
        if (typeof option.orientation == 'undefined' || option.orientation == "horizontal") {
            const resizeObserver = new ResizeObserver((entries) => {
                if (!dxSplitter.option("items[0].collapsed") && !dxSplitter.option("items[1].collapsed")) {
                    for (const entry of entries) {
                        const leftWidth = dxSplitter.option("myLeftWidth")
                        const rightGrow = parseFloat(rightItem.css("flexGrow"), 10);
                        const rightWidth = parseFloat(rightItem.css("width").replace("px", ""), 10);
                        const leftGrow = rightGrow * leftWidth / rightWidth;
                        leftItem.css("flexGrow", leftGrow);
                    }
                }
            });
            $DivSplitter = $("<div style='width:100%;height:100%;'/>").appendTo(container)
            resizeObserver.observe($DivSplitter.get(0));
        } else {
            $DivSplitter = $("<div style='width:100%;height:100%;'/>").appendTo(container)
        }

        dxSplitter = $DivSplitter.dxSplitter({
            separatorSize: 25,
            orientation: ((typeof option.orientation == 'undefined') ? "horizontal" : option.orientation),
            items: [{
                collapsible: ((typeof option.collapsibleLeft == 'undefined') ? false : option.collapsibleLeft),
                collapsed: ((typeof option.context_grid != 'undefined') ? option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_left : false),
                minSize: option.minSizeLeft,
                size: ((typeof option.context_grid != 'undefined') ? parseInt(option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_left) : null),
                visible: true,
                template(itemData, itemIndex, itemElement) {
                    itemElement.css("overflow", "hidden")
                    itemElement.addClass("left");
                    if ($DivLeft == null) { $DivLeft = itemElement }
                    else {
                        itemElement.append($DivLeft.parent())
                        $DivLeft = itemElement
                    }
                }
            }, {
                collapsible: ((typeof option.collapsibleRight == 'undefined') ? false : option.collapsibleRight),
                collapsed: ((typeof option.forceCollapsedRight != 'undefined') ? option.forceCollapsedRight : ((typeof option.context_grid != 'undefined') ? option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right : false)),
                minSize: option.minSizeRight,
                visible: true,
                template(itemData, itemIndex, itemElement) {
                    itemElement.css("overflow", "hidden")
                    if ($DivRight == null) { $DivRight = itemElement }
                    else {
                        itemElement.append($DivRight.parent())
                        $DivRight = itemElement
                    }
                }
            }],
            onItemCollapsed: function (e) {
                if (typeof option.context_grid != 'undefined') {
                    switch (e.itemIndex) {
                        case 0: option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_left = true; break;
                        case 1:
                            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right = true;
                            if (typeof option.onItemRightCollapsed != 'undefined') option.onItemRightCollapsed()
                            break;
                    }
                    option.bddCtrl.mSaveParaJsonUtilisateur();
                }
                onResizeEnd(e)
                //if (typeof option.onResizeEnd != 'undefined') option.onResizeEnd()
            },
            onItemExpanded: function (e) {
                if (typeof option.context_grid != 'undefined') {
                    switch (e.itemIndex) {
                        case 0:
                            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_left = false;
                            e.component.instance().option("items[0].size", option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_left)
                            //option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_left = e.component.instance().option("items[0].size")
                            break;
                        case 1:
                            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right = false;
                            if (typeof option.onItemRightExpanded != 'undefined') option.onItemRightExpanded()
                            break;
                    }
                    option.bddCtrl.mSaveParaJsonUtilisateur();
                }
                onResizeEnd(e)
                //if (typeof option.onResizeEnd != 'undefined') option.onResizeEnd()
            },
            onResize: function (e) {
                if (typeof option.onResize != 'undefined') option.onResize()
            },
            onResizeEnd: function (e) {
                onResizeEnd(e)
                //if (typeof option.orientation == 'undefined' || option.orientation == "horizontal") saveLeftWidth(e)
                //if (typeof option.context_grid != 'undefined' && option.bddCtrl.utiCourantParaJson) {
                //    window.setTimeout(function () {
                //        option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_left = parseInt(e.component.instance().option("items[0].size"))
                //        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_right != 'undefined') {
                //            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_right = parseInt(e.component.instance().option("items[1].size"))
                //        }
                //        option.bddCtrl.mSaveParaJsonUtilisateur();
                //    }, 0)
                //}
                //if (typeof option.onResizeEnd != 'undefined') option.onResizeEnd()
            },
            onContentReady: function (e) {
                if (typeof option.orientation == 'undefined' || option.orientation == "horizontal") saveLeftWidth(e)
                if (typeof option.context_grid != 'undefined') {
                    window.setTimeout(function () {
                        if (typeof option.forceCollapsedRight == 'undefined' && option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right) {
                            e.component.option("items[1].collapsed", true)
                        }
                    }, 0)
                }
            }
        }).dxSplitter("instance");
        leftItem = dxSplitter.element().find(".dx-splitter-item:has(.left)");
        rightItem = dxSplitter.element().find(".dx-splitter-item:not(:has(.left))");


        if (option.withMarge) {
            dxSplitter.element().css("padding", "8px")
            //$DivRight.css({ "padding": "10px 10px 10px 0px", "box-sizing": "border-box" })
            $DivContainerRight = $("<div style='width:100%;height:100%;border:" + theme.border + ";background-color:" + theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ", 0.2)") + ";'  class=''/>").appendTo($DivRight)
            //$DivLeft.css({ "padding": "10px 0 10px 10px", "box-sizing": "border-box" })
            $DivContainerLeft = $("<div style='width:100%;height:100%;border:" + theme.border + ";background-color:" + theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ", 0.2)") + ";'  class=''/>").appendTo($DivLeft)
            //$DivRight.css({ "padding": "10px 10px 10px 0px", "box-sizing": "border-box" })
            //$DivContainerRight = $("<div style='width:100%;height:100%;border:" + theme.border + ";background-color:" + theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ", 0.2)") + ";'  class=''/>").appendTo($DivRight)
            //$DivLeft.css({ "padding": "10px 0 10px 10px", "box-sizing": "border-box" })
            //$DivContainerLeft = $("<div style='width:100%;height:100%;border:" + theme.border + ";background-color:" + theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ", 0.2)") + ";'  class=''/>").appendTo($DivLeft)
        } else {
            $DivContainerRight = $DivRight
            $DivRight.css("border-left",theme.border)
            $DivContainerLeft = $DivLeft
            $DivLeft.css("border-right", theme.border)
        }
    }

    function onResizeEnd(e) {
        if (typeof option.orientation == 'undefined' || option.orientation == "horizontal") saveLeftWidth(e)
        if (typeof option.context_grid != 'undefined' && option.bddCtrl.utiCourantParaJson) {
            window.setTimeout(function () {
                option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_left = parseInt(e.component.instance().option("items[0].size"))
                if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_right != 'undefined') {
                    option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_right = parseInt(e.component.instance().option("items[1].size"))
                }
                option.bddCtrl.mSaveParaJsonUtilisateur();
            }, 0)
        }
        if (typeof option.onResizeEnd != 'undefined') option.onResizeEnd()
    }
    function saveLeftWidth(e) {
        const leftItem = $(e.element).find(".dx-splitter-item:has(.left)");
        const leftWidth = parseFloat(leftItem.css("width").replace("px", ""), 10);
        e.component.option("myLeftWidth", leftWidth);
    }

    this.mConstruitLeft = function (func) {
        $DivContainerLeft.empty()
        func($DivContainerLeft)
    }

    this.mConstruitRight = function (func) {
        $DivContainerRight.empty()
        func($DivContainerRight)
    }

    this.isRightVisible = function () { return !dxSplitter.option("items[1].collapsed") }
    this.mHideRight = function () {
        dxSplitter.option("items[1].collapsed", true)
        if (typeof option.context_grid != 'undefined' && option.bddCtrl.utiCourantParaJson) {
            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right = true
            option.bddCtrl.mSaveParaJsonUtilisateur();
            //if (typeof option.onResizeEnd != 'undefined') window.setTimeout(function () { option.onResizeEnd() }
        }
    }
    this.mShowRight = function () {
        dxSplitter.option("items[1].collapsed", false)
        if (typeof option.context_grid != 'undefined' && option.bddCtrl.utiCourantParaJson) {
            if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_right != "undefined") {
                dxSplitter.option("items[0].size", container.innerWidth() - option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_width_right)
            }
            if (typeof option.onResizeEnd != 'undefined') option.onResizeEnd()
            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right = false
            option.bddCtrl.mSaveParaJsonUtilisateur();
        }
    }

    this.isLeftVisible = function () { return !dxSplitter.option("items[0].collapsed") }
    this.mHideLeft = function () {
        dxSplitter.option("items[0].collapsed", true)
        if (typeof option.context_grid != 'undefined' && option.bddCtrl.utiCourantParaJson) {
            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_left = true
            option.bddCtrl.mSaveParaJsonUtilisateur();
        }
    }
    this.mShowLeft = function () {
        dxSplitter.option("items[0].collapsed", false)
        if (typeof option.context_grid != 'undefined' && option.bddCtrl.utiCourantParaJson) {
            option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_left = false
            option.bddCtrl.mSaveParaJsonUtilisateur();
        }
    }

    this.destroy = function () {
    }

    this.element = function () {
        return container
    }
    this.component = function () { return dxSplitter }
    //this.dispose = function () {
    //    if (dxSplitter) dxSplitter.dispose()
    //}

    mConstruit();
}